import { Box, Typography } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import RoomIcon from '@mui/icons-material/Room';
import WidgetsIcon from '@mui/icons-material/Widgets';
import TouchAppIcon from '@mui/icons-material/TouchApp';

export const TriggerAreaCard = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: 16,
  borderRadius: 8,
  backgroundColor: 'var(--am-accent-surface)',
  marginBottom: 16,
});

export const TriggerAreaCardLabel = styled(Typography)({
  fontSize: '12px',
  color: 'var(--am-text-secondary)',
  lineHeight: 1.2,
}) as typeof Typography;

export const TriggerAreaCardTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.primary.dark,
  fontSize: '15px',
  marginTop: 4,
})) as typeof Typography;

export const TriggerAreaCardPinIcon = styled(RoomIcon)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: 20,
  flexShrink: 0,
}));

export const TriggerAreaCardObjectIcon = styled(WidgetsIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 20,
  flexShrink: 0,
}));

export const TriggerTogglePinIcon = styled(RoomIcon)(({ theme }) => ({
  fontSize: 15,
  marginRight: 6,
  color: theme.palette.error.main,
}));

export const TriggerToggleTouchIcon = styled(TouchAppIcon)(({ theme }) => ({
  fontSize: 15,
  marginRight: 6,
  color: theme.palette.warning.main,
}));

export const TriggerInfoBox = styled(Box)(({ theme }) => ({
  padding: 12,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: 'var(--am-surface)',
  border: '1px solid var(--am-border)',
}));

export const UiClickSectionLabel = styled(Typography)({
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: 'var(--am-text-secondary)',
  marginBottom: 6,
}) as typeof Typography;

export const NoaPanelPreview = styled(Box)({
  borderRadius: 12,
  backgroundColor: '#3d3d3d',
  padding: '12px 8px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 16,
});

export const NoaPanelPreviewLabel = styled(Typography)({
  fontSize: '11px',
  fontWeight: 600,
  letterSpacing: '0.12em',
  textTransform: 'uppercase' as const,
  color: 'rgba(255,255,255,0.35)',
}) as typeof Typography;

export const NoaPanelPreviewButton = styled(Box)({
  border: '2px solid rgba(255,255,255,0.7)',
  borderRadius: '50px',
  padding: '12px 40px',
  color: 'white',
  fontWeight: 600,
  fontSize: '15px',
  minWidth: 220,
  textAlign: 'center' as const,
  backgroundColor: '#4B52D4',
});

export const AllowSkipBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: 16,
  borderRadius: 8,
  border: '1px solid var(--am-border)',
  backgroundColor: 'var(--am-surface)',
});

export const AllowSkipTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: 1.3,
  color: 'var(--am-text-primary)',
}) as typeof Typography;

export const AllowSkipDescription = styled(Typography)({
  fontSize: '13px',
  color: 'var(--am-text-secondary)',
  lineHeight: 1.3,
}) as typeof Typography;
